import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { LabelField } from 'components'
import { Chip } from 'components/chips'
import { InboundTripDto } from 'dtos'
import moment from 'moment'
import { formatDate } from 'utils'

interface InboundTripsHeroCardProps {
  inboundTrip: InboundTripDto
}

// TODO: Rename to Hero Card!
// Maxwell Sommer 09/11/2024
export default function InboundTripsHeroCard({ children, inboundTrip }: React.PropsWithChildren<InboundTripsHeroCardProps>) {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2} alignItems='flex-start'>
          <Grid item xs={12} container alignContent='center' justifyContent='space-between'>
            <Grid item xs={12} sm='auto' container spacing={1}>
              <Grid item>
                <Typography fontWeight='bold' variant='h5'>
                  Inbound Trip #{inboundTrip.inboundTripNumber}
                </Typography>
              </Grid>

              <Grid item>
                {inboundTrip.isLocked ? <Chip variant='red'>Locked</Chip> : <Chip variant='green'>Unlocked</Chip>}
              </Grid>
            </Grid>

            <Grid item xs={12} sm='auto'>
              {children}
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LabelField
                ellipsis
                label='Inbound Transporter Company'
                value={inboundTrip.inboundTransporterCompany?.name}
                to={
                  inboundTrip.inboundTransporterCompany ? `/companies/${inboundTrip.inboundTransporterCompany.companyGuid}` : ''
                }
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LabelField
                ellipsis
                label='Inbound Transporter Company Email'
                value={inboundTrip.inboundTransporterCompanyEmail}
                to={inboundTrip.inboundTransporterCompanyEmail ? `mailto:${inboundTrip.inboundTransporterCompanyEmail}` : ''}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LabelField label='Entry #' value={inboundTrip.entryNumber} />
            </Grid>

            <Grid item xs={12} sm={3}>
              <LabelField label='Entry Date' value={inboundTrip.entryDate ? formatDate(inboundTrip.entryDate) : ''} />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
